import { c as _c } from "react/compiler-runtime";
import { AspectRatio, Box, Button, Flex, HStack, Heading, Stack, Text, VStack, Separator } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { useHover } from '@uidotdev/usehooks';
import { MdPlayCircle } from 'react-icons/md';
type PodcastCardProps = {
  image?: string;
  summary?: string;
  url?: string;
  title?: string;
  tag?: string;
  releaseDate?: string;
  textDir?: string;
  vertical?: boolean;
};
export const PodcastCard = props => {
  const $ = _c(55);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const [ref, hovering] = useHover();
  const t0 = props.url || "#";
  const t1 = props.vertical ? "container" : null;
  const t2 = props.vertical ? "2xl" : null;
  const t3 = props.vertical ? "xl" : null;
  let t4;
  if ($[0] !== getBreakpointValue || $[1] !== props.vertical) {
    t4 = props.vertical ? "column" : getBreakpointValue(["column", "column", "column", "row"]);
    $[0] = getBreakpointValue;
    $[1] = props.vertical;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = props.vertical ? 0 : 12;
  const t6 = props.vertical ? "backgroundTertiary" : null;
  let t7;
  if ($[3] !== t6) {
    t7 = {
      bgColor: t6
    };
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const t8 = props.vertical ? null : 2;
  const t9 = `url('${props.image}')`;
  const t10 = hovering && "scale(1.1)";
  let t11;
  if ($[5] !== t10 || $[6] !== t9) {
    t11 = <AspectRatio borderRadius="2xl" boxShadow="sm" overflow="hidden" position="relative" ratio={1.7777777777777777} width="full"><Box background={t9} backgroundPosition="center center" backgroundRepeat="no-repeat" backgroundSize="cover" borderRadius="2xl" overflow="hidden" transform={t10} transition="all 0.2s ease-in" width="full" /></AspectRatio>;
    $[5] = t10;
    $[6] = t9;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== t11 || $[9] !== t8) {
    t12 = <Box flex={t8} position="relative" width="full">{t11}</Box>;
    $[8] = t11;
    $[9] = t8;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  const t13 = props.vertical ? 0 : 2;
  const t14 = props.vertical ? "2xl" : null;
  const t15 = props.vertical ? 8 : 0;
  const t16 = props.vertical ? "full" : null;
  let t17;
  if ($[11] !== props.tag) {
    t17 = <Text textStyle="label">{"Episode "}{props.tag}</Text>;
    $[11] = props.tag;
    $[12] = t17;
  } else {
    t17 = $[12];
  }
  let t18;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Separator height="4" orientation="vertical" />;
    $[13] = t18;
  } else {
    t18 = $[13];
  }
  let t19;
  if ($[14] !== props.releaseDate) {
    t19 = props.releaseDate && <Text textStyle="label">{props.releaseDate}</Text>;
    $[14] = props.releaseDate;
    $[15] = t19;
  } else {
    t19 = $[15];
  }
  let t20;
  if ($[16] !== t17 || $[17] !== t19) {
    t20 = <HStack align="center" color="colorPalette.fg/50">{t17}{t18}{t19}</HStack>;
    $[16] = t17;
    $[17] = t19;
    $[18] = t20;
  } else {
    t20 = $[18];
  }
  let t21;
  if ($[19] !== getBreakpointValue) {
    t21 = getBreakpointValue(["3xl"]);
    $[19] = getBreakpointValue;
    $[20] = t21;
  } else {
    t21 = $[20];
  }
  let t22;
  if ($[21] !== props.title || $[22] !== t21) {
    t22 = <Heading size={t21}>{props.title}</Heading>;
    $[21] = props.title;
    $[22] = t21;
    $[23] = t22;
  } else {
    t22 = $[23];
  }
  let t23;
  if ($[24] !== props.summary) {
    t23 = <Text color="colorPalette.fg" fontSize="md">{props.summary}</Text>;
    $[24] = props.summary;
    $[25] = t23;
  } else {
    t23 = $[25];
  }
  let t24;
  if ($[26] !== t22 || $[27] !== t23) {
    t24 = <VStack align="flex-start" gap={6} maxWidth="400px">{t22}{t23}</VStack>;
    $[26] = t22;
    $[27] = t23;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  const t25 = hovering ? "solid" : "outline";
  let t26;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <MdPlayCircle />;
    $[29] = t26;
  } else {
    t26 = $[29];
  }
  let t27;
  if ($[30] !== t25) {
    t27 = <Button size="lg" variant={t25}>{t26}Listen now</Button>;
    $[30] = t25;
    $[31] = t27;
  } else {
    t27 = $[31];
  }
  let t28;
  if ($[32] !== t14 || $[33] !== t15 || $[34] !== t16 || $[35] !== t20 || $[36] !== t24 || $[37] !== t27) {
    t28 = <VStack align="flex-start" borderRadius={t14} gap={8} justify="center" padding={t15} width={t16}>{t20}{t24}{t27}</VStack>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
    $[35] = t20;
    $[36] = t24;
    $[37] = t27;
    $[38] = t28;
  } else {
    t28 = $[38];
  }
  let t29;
  if ($[39] !== t13 || $[40] !== t28) {
    t29 = <Flex flex={t13} justify="flex-start" width="full">{t28}</Flex>;
    $[39] = t13;
    $[40] = t28;
    $[41] = t29;
  } else {
    t29 = $[41];
  }
  let t30;
  if ($[42] !== ref || $[43] !== t1 || $[44] !== t12 || $[45] !== t2 || $[46] !== t29 || $[47] !== t3 || $[48] !== t4 || $[49] !== t5 || $[50] !== t7) {
    t30 = <Stack ref={ref} align="center" bgColor={t1} borderRadius={t2} boxShadow={t3} direction={t4} gap={t5} justify="space-between" transition="background-color 0.2s ease-in" _hover={t7}>{t12}{t29}</Stack>;
    $[42] = ref;
    $[43] = t1;
    $[44] = t12;
    $[45] = t2;
    $[46] = t29;
    $[47] = t3;
    $[48] = t4;
    $[49] = t5;
    $[50] = t7;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== t0 || $[53] !== t30) {
    t31 = <Box width="full"><NextLink href={t0} prefetch={false}>{t30}</NextLink></Box>;
    $[52] = t0;
    $[53] = t30;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  return t31;
};